"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ThemeProvider = _interopRequireDefault(require("@jobmatchme/ui/es/provider/ThemeProvider"));

var _ProgressStepper = require("@jobmatchme/ui/es/components/styleguide/ProgressStepper");

var _translatedPaths = _interopRequireDefault(require("@jobmatchme/landing-page-components/es/utils/translatedPaths.js"));

var _LogoJMM = _interopRequireDefault(require("@jobmatchme/ui/es/components/LogoJMM"));

var _Header = _interopRequireDefault(require("@jobmatchme/ui/es/components/Header"));

var _jsxRuntime = require("react/jsx-runtime");

var FunnelHeader = function FunnelHeader(_ref) {
  var index = _ref.index,
      stepsLength = _ref.stepsLength,
      discriminator = _ref.discriminator,
      progressStepperVariant = _ref.progressStepperVariant,
      _ref$sectionSeparator = _ref.sectionSeparatorPositions,
      sectionSeparatorPositions = _ref$sectionSeparator === void 0 ? [] : _ref$sectionSeparator,
      actionButton = _ref.actionButton,
      target = _ref.target;
  var ActionButton = actionButton;

  var logoClickHandler = function logoClickHandler() {
    if (target === 'bc') {
      window.open("/".concat((0, _translatedPaths.default)('bc'), "/app/"), '_self');
    } else {
      window.open("/", '_self');
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {
      logo: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          marginTop: '8px',
          width: '100%',
          maxWidth: '200px'
        },
        onClick: logoClickHandler,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LogoJMM.default, {
          exact: true,
          width: "50",
          height: "50",
          variant: "circleFull",
          pointer: true
        })
      }),
      actionButton: actionButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(ActionButton, {
        discriminator: discriminator
      })
    }), progressStepperVariant && sectionSeparatorPositions.indexOf(index) < 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThemeProvider.default, {
      variant: target === 'bc' ? 'jmm' : discriminator ? discriminator : 'jmm',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProgressStepper.ProgressStepper, {
        index: index,
        stepsLength: stepsLength,
        sectionSeparatorPositions: sectionSeparatorPositions,
        variant: progressStepperVariant
      })
    })]
  });
};

var _default = /*#__PURE__*/_react.default.memo(FunnelHeader);

exports.default = _default;